"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
// Relements
var modal_1 = __importDefault(require("relements/build/esm/overlays/modal"));
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var search_1 = __importDefault(require("relements/build/esm/input/search"));
var icon_1 = __importDefault(require("relements/build/esm/ui/icon"));
var FileIcon_1 = __importDefault(require("relements/build/esm/ui/icons/FileIcon"));
var DownloadIcon_1 = __importDefault(require("relements/build/esm/ui/icons/DownloadIcon"));
var loader_1 = __importDefault(require("relements/build/esm/ui/loader"));
var BinIcon_1 = __importDefault(require("relements/build/esm/ui/icons/BinIcon"));
var MogamboConstants_1 = require("@src/constants/MogamboConstants");
var BotActions_1 = require("@src/actions/BotActions");
var api_1 = require("../store/api");
require("./ActionDrawer.scss");
var ACCEPT_TYPES = [
    'application/pdf',
    'text/plain',
    'text/html',
    'application/xml',
];
var VertexFileModal = function (_a) {
    var active = _a.active, onClose = _a.onClose, domainId = _a.domainId, appId = _a.appId;
    var _b = react_1.useState([]), files = _b[0], setFiles = _b[1];
    var _c = react_1.useState([]), filteredFiles = _c[0], setFilteredFiles = _c[1];
    var _d = react_1.useState(''), searchTerm = _d[0], setSearchTerm = _d[1];
    var _e = react_1.useState(false), isLoadingFiles = _e[0], setIsLoadingFiles = _e[1];
    var _f = react_1.useState(false), isUploadingFiles = _f[0], setIsUploadingFiles = _f[1];
    var _g = react_1.useState(new Set()), loadingFileNames = _g[0], setLoadingFileNames = _g[1];
    var fileInputRef = react_1.useRef(null);
    var fetchFiles = react_1.useCallback(function () {
        setIsLoadingFiles(true);
        api_1.getFileData(domainId, appId)
            .then(function (data) {
            setFiles(data.response.body.files);
            setFilteredFiles(data.response.body.files);
        })["finally"](function () {
            setIsLoadingFiles(false);
        });
    }, [domainId, appId]);
    var validateFile = function (allowedFileTypes, file, fileType) {
        var isValid;
        var fileSizeInMB = file.size / (1024 * 1024);
        if (fileSizeInMB > 10) {
            return BotActions_1.createAlert("File " + file.name + " size exceeds the 10MB limit. Please upload a smaller file.", '', MogamboConstants_1.AlertTypes.NEGATIVE);
        }
        if (fileType === '') {
            isValid =
                file.name.includes('.pdf') ||
                    file.name.includes('.html') ||
                    file.name.includes('.xml') ||
                    file.name.includes('.txt');
        }
        else {
            isValid = allowedFileTypes.includes(fileType);
        }
        if (!isValid) {
            BotActions_1.createAlert('Invalid file type. Please upload a PDF, TXT, HTML or XML file.', '', MogamboConstants_1.AlertTypes.NEGATIVE);
        }
        return isValid;
    };
    var handleFileUpload = function (e) {
        var uploadedFiles = e.target.files;
        if (!uploadedFiles.length)
            return;
        var body = new FormData();
        Array.from(uploadedFiles).forEach(function (file) {
            var isValid = validateFile(ACCEPT_TYPES, file, file.type);
            if (isValid) {
                body.append('files', file);
            }
        });
        var totalNumberOfFiles = body.getAll('files').length;
        if (totalNumberOfFiles > 5) {
            BotActions_1.createAlert('Upload limit exceeded. You can upload up to 5 files at a time.', '', MogamboConstants_1.AlertTypes.NEGATIVE);
            return;
        }
        if (totalNumberOfFiles > 0) {
            setIsUploadingFiles(true);
            api_1.uploadFileToVertex(domainId, appId, 'upload', body)
                .then(function (res) {
                if (res.success) {
                    BotActions_1.createAlert('Files uploaded successfully.', '', MogamboConstants_1.AlertTypes.POSITIVE);
                    fetchFiles();
                }
            })["finally"](function () {
                setIsUploadingFiles(false);
            });
        }
    };
    var handleDelete = function (fileName) {
        setLoadingFileNames(function (prev) { return new Set(prev).add(fileName); });
        api_1.downloadOrDeleteFile(domainId, appId, 'delete', {}, fileName)
            .then(function (res) {
            if (res.success) {
                setFiles(function (prev) { return prev.filter(function (f) { return !f.name.includes(fileName); }); });
                setFilteredFiles(function (prev) {
                    return prev.filter(function (f) { return !f.name.includes(fileName); });
                });
                BotActions_1.createAlert('File deleted successfully.', '', MogamboConstants_1.AlertTypes.POSITIVE);
            }
            else {
                BotActions_1.createAlert('Error deleting file.', '', MogamboConstants_1.AlertTypes.NEGATIVE);
            }
        })["catch"](function (e) {
            BotActions_1.createAlert(e.message || 'Error deleting file.', '', MogamboConstants_1.AlertTypes.NEGATIVE);
        })["finally"](function () {
            setLoadingFileNames(function (prev) {
                var newSet = new Set(prev);
                newSet["delete"](fileName);
                return newSet;
            });
        });
    };
    var header = (react_1["default"].createElement(box_1["default"], { padding: "8px 12px" },
        react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold" }, "Add/Edit Files")));
    var footer = (react_1["default"].createElement(box_1["default"], { padding: "0", mb: "8px", width: "100%", justifyContent: "flex-end", onClick: function (e) {
            if (!isUploadingFiles && fileInputRef.current) {
                fileInputRef.current.click();
                e.stopPropagation();
            }
        } },
        isUploadingFiles && (react_1["default"].createElement(box_1["default"], { padding: "0", style: { gap: '8px' }, alignItems: "center" },
            react_1["default"].createElement(loader_1["default"], { size: 20 }),
            react_1["default"].createElement(text_1["default"], null, "Uploading..."))),
        !isUploadingFiles && (react_1["default"].createElement(icon_1["default"], { themed: true, src: "plus", size: "big", prefixClassName: "addFile", tooltip: "Add Files" })),
        react_1["default"].createElement("input", { accept: ACCEPT_TYPES.join(','), ref: fileInputRef, onChange: handleFileUpload, type: "file", multiple: true, style: { display: 'none' } })));
    react_1.useEffect(function () {
        if (domainId && appId) {
            fetchFiles();
        }
    }, [domainId, appId, fetchFiles]);
    return (react_1["default"].createElement(modal_1["default"], { themed: true, active: active, maxHeight: "800px", padding: "0px", header: header, footer: footer, footerBorder: false, onClose: onClose },
        react_1["default"].createElement(box_1["default"], { flexDirection: "column", width: "100%", padding: "0 8px", style: { maxWidth: '600px' } },
            react_1["default"].createElement(search_1["default"], { placeholder: "Search Files", style: { borderRadius: '4px', height: '36px' }, options: files, value: searchTerm, onType: function (searchValue) { return setSearchTerm(searchValue); }, searchKeys: ['name'], onChange: function (searchResults) {
                    setFilteredFiles(searchResults);
                } }),
            isLoadingFiles && (react_1["default"].createElement(box_1["default"], { height: "200px", alignItems: "center", justifyContent: "center", flexDirection: "column", style: { gap: '16px' } },
                react_1["default"].createElement(loader_1["default"], { size: 40 }),
                react_1["default"].createElement(text_1["default"], null, "Loading files..."))),
            !isLoadingFiles && filteredFiles && filteredFiles.length > 0 && (react_1["default"].createElement(box_1["default"], { padding: "16px 0", flexDirection: "column", width: "100%", style: { overflow: 'auto' } }, filteredFiles.map(function (fileItem) {
                var fileName = fileItem.name.split('/')[1];
                var isLoading = loadingFileNames.has(fileName);
                return (react_1["default"].createElement(box_1["default"], { key: fileName, padding: "16px 0", alignItems: "center", justifyContent: "space-between" },
                    react_1["default"].createElement(box_1["default"], { padding: "0", style: { gap: '4px' }, alignItems: "center" },
                        react_1["default"].createElement(FileIcon_1["default"], null),
                        react_1["default"].createElement(text_1["default"], null, fileName)),
                    react_1["default"].createElement(box_1["default"], { padding: "0", style: { gap: '8px' }, alignItems: "center" },
                        isLoading && react_1["default"].createElement(loader_1["default"], { size: 20 }),
                        !isLoading && (react_1["default"].createElement(react_1["default"].Fragment, null,
                            react_1["default"].createElement(DownloadIcon_1["default"], { style: { cursor: 'pointer', marginTop: '2px' }, tooltip: "Download", onClick: function () {
                                    setLoadingFileNames(function (prev) {
                                        return new Set(prev).add(fileName);
                                    });
                                    api_1.downloadOrDeleteFile(domainId, appId, 'download', {}, fileName)
                                        .then(function (res) {
                                        window.open(res.response.body.file_url, '_blank', 'noopener');
                                    })["finally"](function () {
                                        setLoadingFileNames(function (prev) {
                                            var newSet = new Set(prev);
                                            newSet["delete"](fileName);
                                            return newSet;
                                        });
                                    });
                                } }),
                            react_1["default"].createElement(BinIcon_1["default"], { tooltip: "Delete", style: { cursor: 'pointer' }, onClick: function () {
                                    BotActions_1.showConfirmationDialog({
                                        okTitle: 'Delete',
                                        cancelTitle: 'Cancel',
                                        title: 'Are you sure you want to delete the file?',
                                        message: 'You will lose this file and will not be able to recover it.',
                                        onOk: function () {
                                            handleDelete(fileName);
                                        },
                                        onCancel: function () { },
                                        okActionType: 'danger',
                                    });
                                } }))))));
            }))),
            !isLoadingFiles && (!filteredFiles || filteredFiles.length === 0) && (react_1["default"].createElement(box_1["default"], { height: "100px", alignItems: "center", justifyContent: "center" },
                react_1["default"].createElement(text_1["default"], null, "No files uploaded."))))));
};
exports["default"] = VertexFileModal;
